import { takeLatest } from 'redux-saga/effects';

import SagaHelpers from '../../common/helpers/SagaHelpers';
import {
    GET_PERFEED_FEEDBACKS_SUCCESS,
    GET_PERFEED_FEEDBACKS_FAIL,
    GET_PERFEED_FEEDBACKS,
    GET_PERFEED_REQUESTS,
    GET_PERFEED_REQUESTS_SUCCESS,
    GET_PERFEED_REQUESTS_FAIL,
    GET_PERFEED_REQUESTS_SETTINGS,
    GET_PERFEED_REQUESTS_SETTINGS_SUCCESS,
    GET_PERFEED_REQUESTS_SETTINGS_FAIL,
    SAVE_PERFEED_REQUESTS_SETTINGS,
    SAVE_PERFEED_REQUESTS_SETTINGS_SUCCESS,
    SAVE_PERFEED_REQUESTS_SETTINGS_FAIL,
} from '../../actions/PerfeedActions';
import { PerfeedService } from '../../services/PerfeedService';

export function* getFeedbacks(action) {
    yield SagaHelpers.handleRequest({
        request: [PerfeedService.getFeedbacks, action.payload],
        actions: [
            (payload) => ({ type: GET_PERFEED_FEEDBACKS_SUCCESS, payload }),
            (error) => ({ type: GET_PERFEED_FEEDBACKS_FAIL, error }),
        ],
    });
}

export function* getRequests(action) {
    yield SagaHelpers.handleRequest({
        request: [PerfeedService.getRequests, action.payload],
        actions: [
            (payload) => ({ type: GET_PERFEED_REQUESTS_SUCCESS, payload }),
            (error) => ({ type: GET_PERFEED_REQUESTS_FAIL, error }),
        ],
    });
}

export function* getRequestSettings(action) {
    yield SagaHelpers.handleRequest({
        request: [PerfeedService.getRequestSettings, action.payload],
        actions: [
            (payload) => ({
                type: GET_PERFEED_REQUESTS_SETTINGS_SUCCESS,
                payload,
            }),
            (error) => ({ type: GET_PERFEED_REQUESTS_SETTINGS_FAIL, error }),
        ],
    });
}

export function* saveRequestSettings(action) {
    yield SagaHelpers.handleRequest({
        request: [PerfeedService.saveRequestSettings, action.payload],
        actions: [
            () => ({
                type: SAVE_PERFEED_REQUESTS_SETTINGS_SUCCESS,
                payload: action.payload,
            }),
            (error) => ({ type: SAVE_PERFEED_REQUESTS_SETTINGS_FAIL, error }),
        ],
    });
}

export default [
    takeLatest(GET_PERFEED_FEEDBACKS, getFeedbacks),
    takeLatest(GET_PERFEED_REQUESTS, getRequests),
    takeLatest(GET_PERFEED_REQUESTS_SETTINGS, getRequestSettings),
    takeLatest(SAVE_PERFEED_REQUESTS_SETTINGS, saveRequestSettings),
];
